import * as React from "react";
import type { SVGProps } from "react";
const SvgToast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#toast_svg__a)">
      <path d="M7.61 22.54h-.18l-5.51-1a1 1 0 0 1-.81-1.16 1 1 0 0 1 1.15-.81l5.52 1a1 1 0 0 1 .81 1.2 1 1 0 0 1-.98.77" />
      <path d="M4.85 22.06h-.18a1 1 0 0 1-.81-1.16l.73-4.13a1 1 0 0 1 1.15-.83 1 1 0 0 1 .81 1.15l-.73 4.14a1 1 0 0 1-.97.83" />
      <path d="M6.53 18.01a6.3 6.3 0 0 1-1.13-.11 5.7 5.7 0 0 1-3.33-1.78 4.21 4.21 0 0 1-1-3.55 1 1 0 0 1 0-.14l1.57-4.66a1 1 0 0 1 1.1-.71l6.9 1.21a1 1 0 0 1 .82 1l-.16 4.94v.15a4.21 4.21 0 0 1-2.16 3c-.802.432-1.7.656-2.61.65m-3.51-5a2.24 2.24 0 0 0 .55 1.76 3.77 3.77 0 0 0 2.17 1.17 3.78 3.78 0 0 0 2.44-.32 2.18 2.18 0 0 0 1.13-1.53l.14-4-5.19-.91z" />
      <path d="M8.74 15.58a4.52 4.52 0 0 1-3.29-1.42 2.51 2.51 0 0 0-3-.52 1 1 0 0 1-1.401-1.207 1 1 0 0 1 .501-.583 4.53 4.53 0 0 1 5.32.94 2.5 2.5 0 0 0 3 .52 1 1 0 0 1 1.34.44 1 1 0 0 1-.47 1.34 4.4 4.4 0 0 1-2 .49M15.87 22.54a1 1 0 0 1-1-.82 1 1 0 0 1 .87-1.16l5.52-1a1 1 0 0 1 .34 1.97l-5.51 1z" />
      <path d="M18.63 22.06a1 1 0 0 1-1-.83l-.73-4.14a1 1 0 0 1 .84-1.15 1 1 0 0 1 1.16.81l.73 4.13a1 1 0 0 1-.81 1.16z" />
      <path d="M16.95 18.01a5.4 5.4 0 0 1-2.62-.64 4.21 4.21 0 0 1-2.16-3v-.15l-.16-4.94a1 1 0 0 1 .82-1l6.9-1.21a1 1 0 0 1 1.11.7l1.54 4.7a1 1 0 0 1 0 .14 4.21 4.21 0 0 1-1 3.55 5.7 5.7 0 0 1-3.33 1.78 6.3 6.3 0 0 1-1.1.07m-2.79-3.92a2.18 2.18 0 0 0 1.13 1.53 3.78 3.78 0 0 0 2.44.32 3.77 3.77 0 0 0 2.18-1.17 2.24 2.24 0 0 0 .55-1.82l-1.25-3.8-5.19.91z" />
      <path d="M13.16 15.2a1 1 0 0 1-.69-.27 1 1 0 0 1 0-1.41 4.52 4.52 0 0 1 5.27-.94 2.5 2.5 0 0 0 3-.52 1 1 0 0 1 1.41 0 1 1 0 0 1 .05 1.41 4.54 4.54 0 0 1-5.32.94 2.5 2.5 0 0 0-3 .52 1 1 0 0 1-.72.27M15.92 6.59a1 1 0 0 1-.844-.462A1 1 0 0 1 15.1 5.01l1.15-1.64a1 1 0 0 1 1.64 1.15l-1.15 1.64a1 1 0 0 1-.82.43M11.92 5a1 1 0 0 1-1-1V2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1M7.95 6.51a1 1 0 0 1-.82-.43L5.98 4.44a1 1 0 0 1 .995-1.557 1 1 0 0 1 .645.407l1.12 1.64a1 1 0 0 1-.25 1.39.93.93 0 0 1-.54.19" />
    </g>
    <defs>
      <clipPath id="toast_svg__a">
        <path fill="#fff" d="M1 1h21.49v21.55H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgToast;
